import { render, staticRenderFns } from "./walkRecord.vue?vue&type=template&id=e78c9694&scoped=true&"
import script from "./walkRecord.vue?vue&type=script&lang=js&"
export * from "./walkRecord.vue?vue&type=script&lang=js&"
import style0 from "./walkRecord.vue?vue&type=style&index=0&id=e78c9694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78c9694",
  null
  
)

export default component.exports